export default {
  naturezaCollection: [],
};
